module.exports = __webpack_public_path__ + "img/top_icon01.bf5b921.png";